import { useEffect, useMemo } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Param, URLSearchParser } from 'shared/search-adapters'

import type { PageResponse } from './types'

import { FilterParser, type Mode } from './filters'

export function useCheckPagination<I>({
	data,
	isApplied,
	isModal,
	isReady
}: {
	data?: PageResponse<I>
	/** is filter applied */
	isApplied?: boolean
	isModal?: boolean
	isReady?: boolean
}) {
	const [_, setParams] = useSearchParams()

	useEffect(() => {
		if (!(isReady && isApplied && data)) {
			return
		}

		const isPageTooBig = data.total > 0 && data.documents.length === 0

		if (isPageTooBig) {
			setParams(params => {
				decrementPage(params, isModal)
				return params
			})
		}
	}, [data, isReady, isApplied, setParams, isModal])
}

export function useParseUrl(mode: Mode) {
	const { id = '' } = useParams<{ id: string }>()
	const [params] = useSearchParams()

	return useMemo(() => {
		const parser = new FilterParser(params, mode)
		id && parser.saveId(id)
		return parser.result
	}, [id, params, mode])
}

function decrementPage(params: URLSearchParams, isModal = false) {
	const skipKey = isModal ? Param.ModalSkip : Param.Skip
	let skip = URLSearchParser.Skip(params, skipKey)

	if (skip > 0) {
		skip -= URLSearchParser.PageSize(params)

		if (skip > 0) {
			params.set(skipKey, skip.toString())
		} else {
			params.delete(skipKey)
		}
	}
}
